import type { LocationQuery } from 'vue-router'
import type { TasksKanbanFilterParams } from '@ts-tasks-kanban/interfaces'

import { parseArrayParam, parseStringParam } from '@helpers/query-params'

export const parseFilterParams = (query: LocationQuery): TasksKanbanFilterParams => {
  return {
    query: parseStringParam(query, 'query'),
    deadline_from: parseStringParam(query, 'deadline_from'),
    deadline_to: parseStringParam(query, 'deadline_to'),
    resolved_at_from: parseStringParam(query, 'resolved_at_from'),
    resolved_at_to: parseStringParam(query, 'resolved_at_to'),
    assignee_id: parseArrayParam(query, 'assignee_id'),
    task_type: parseArrayParam(query, 'task_type'),
    priority: parseArrayParam(query, 'priority'),
    activation_type: parseArrayParam(query, 'activation_type'),
    alert_type: parseArrayParam(query, 'alert_type'),
    is_new: parseStringParam(query, 'is_new'),
    sort_by: parseStringParam(query, 'sort_by'),
    sort_direction: parseStringParam(query, 'sort_direction'),
    customer_id: parseArrayParam(query, 'customer_id'),
    related_to_id: parseStringParam(query, 'related_to_id'),
    related_to_type: parseStringParam(query, 'related_to_type'),
  }
}

export const buildQueryObject = (params: TasksKanbanFilterParams): Record<string, string> => {
  const query: Record<string, string> = {}

  if (params.query) query.query = params.query
  if (params.deadline_from) query.deadline_from = params.deadline_from
  if (params.deadline_to) query.deadline_to = params.deadline_to
  if (params.resolved_at_from) query.resolved_at_from = params.resolved_at_from
  if (params.resolved_at_to) query.resolved_at_to = params.resolved_at_to
  if (params.is_new) query.is_new = params.is_new
  if (params.sort_by) query.sort_by = params.sort_by
  if (params.sort_direction) query.sort_direction = params.sort_direction
  if (params.related_to_id) query.related_to_id = params.related_to_id
  if (params.related_to_type) query.related_to_type = params.related_to_type

  params.assignee_id.forEach((v, i) => { query[`assignee_id[${i}]`] = v })
  params.task_type.forEach((v, i) => { query[`task_type[${i}]`] = v })
  params.priority.forEach((v, i) => { query[`priority[${i}]`] = v })
  params.activation_type.forEach((v, i) => { query[`activation_type[${i}]`] = v })
  params.alert_type.forEach((v, i) => { query[`alert_type[${i}]`] = v })
  params.customer_id.forEach((v, i) => { query[`customer_id[${i}]`] = v })

  return query
}
